import loadable from "@loadable/component";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import _ from "lodash";

export const componentLoader = (programPath) => {
  // const component = loadable(() => import( /* @vite-ignore */ `@/pages${programPath}`));
  const modules = import.meta.glob("pages/**/*.jsx");
  const envMode = import.meta.env.MODE == "useLocal" ? true : false;

  const normalizedPath = programPath.replace(/\/+/g, "/").replace(/^\//, "");
  const fullPath = `/src/pages/${normalizedPath}`; // 절대 경로로 변경

  const component = envMode
    ? loadable(() => import(/* @vite-ignore */ fullPath))
    : loadable(() => modules[`${fullPath}.jsx`]());

  return component;
};

/**
 * 파라미터가 배열인지 아닌지 체크
 * 배열: true
 * 그외: false
 * @param {*} arr
 * @returns
 */
const chkArray = (arr) => {
  if (arr && arr.length > 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * grid multi sheet excel download
 * @param {*} arrGrid
 * @param {*} colHeader
 * @param {*} style
 * @param {*} fileName
 * @param {*} newArrData
 * @param {*} isCheckedItem
 */
export const saveGridExcel = (
  arrGrid = [],
  colHeader = true,
  style = true,
  fileName = "",
  newArrData = [],
  isCheckedItem = false
) => {
  if (chkArray(arrGrid)) {
    let excelData = "";
    arrGrid.forEach((x, idx) => {
      const flexGrid = x.flexGrid.current.refGrid.current;

      // copy grid data
      const copyGrid = _.cloneDeep(flexGrid);

      if (newArrData.length) {
        copyGrid.itemsSource = newArrData;
      }

      if (isCheckedItem) {
        // expect not checking
        const trueValue = copyGrid.itemsSource.filter((x) => {
          return x.ROW_CHECK === true;
        });

        copyGrid.itemsSource = trueValue;
      }

      // grid data -> excel data
      let _xlsx = wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
        copyGrid,
        {
          includeColumnHeaders: colHeader,
          includeStyles: style,
          includeColumns: function (column) {
            return column.binding !== "ROW_CHECK" && column.binding !== "ROW_STATUS" && column.visible;
          },
        },
        null,
        null,
        (progress) => (this.progressBar.value = progress), //진행률표시기
        true
      );

      // data stack for excel export
      if (!excelData) {
        excelData = _xlsx;
      } else {
        excelData.sheets[idx] = _xlsx.sheets[0];
      }

      // modify sheet name
      if (x.sheetName) excelData.sheets[idx].name = x.sheetName;

      // refresh data source
      copyGrid.itemsSource = flexGrid.itemsSource;

      // refresh height value
      copyGrid.onScrollPositionChanged();
    });

    // exec excel export
    if (excelData) excelData.saveAsync(fileName > "" ? fileName : "FlexGrid.xlsx");
  } else {
    console.error("옳바른 배열 형태가 아닙니다.");
  }
};
